import type { ClientAttributes } from '@src/clients/domain/Client';
import { ClientList } from '@src/clients/domain/Client';
import { Client } from '@src/clients/domain/Client';

interface AgencyAttributes extends ClientAttributes {
  isAgency: true;
  clients: Client[];
}

export class Agency extends Client {
  public readonly clients: ClientList;
  constructor(attributes: AgencyAttributes) {
    super(attributes);
    this.clients = new ClientList(attributes.clients);
  }
}
